<template>
  <div class="gold-view week-value" :class="isCjehApp() ? 'cjeh-app' : ''">
    <div class="header">
      <div class="header-content">
        <div class="header-button header-back" @click="goBack()"></div>
        <h1>净值报送</h1>
      </div>
    </div>
    <div class="view-scroller has-header has-footer">
      <div class="reminder">
        <p>报送须知:</p>
        1.每周前3个工作日报送上周净值数据，每月前5个工作日报送上月净值数据。<br />
        2.如未在规定时间内上报上周或上月净值数据，则不参与上周或上月排名计算。<br />
        3.如有两个月净值数据不齐全则视为自动退赛.在规定时间内月报送或每周报送来保证月度净值数据完整齐全。<br />
        4.如有每周报送，也有月报送，计算月排名时将以月报送数据为准。
        <p v-show="tipShow && i_upload_type === '1'">
          {{ firstTip }}<br v-show="firstTip !== ''" />{{ secondTip }}
        </p>
        <p v-show="monthTipShow && i_upload_type === '2'">
          {{ monthFirstTip }}<br v-show="monthFirstTip !== ''" />{{
            monthSecondTip
          }}
        </p>
      </div>
      <div class="tab-top">
        <div class="row">
          <div
            class="col"
            v-for="(item, index) in tabTabArr"
            :key="index"
            @click="tapClick(index, item.type)"
            :class="selectTabIndex === index ? 'active' : ''"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div
        v-show="i_upload_type == '1'"
        class="upload-box"
        v-for="(item, index) in proList"
        :key="index"
      >
        <div class="upload upload-top">
          <div v-show="!item.showUploadExc">
            <a href="" class="upload-a"
              >*点击上传净值文件
              <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                @change="uploadFile($event, index, item)"
                type="file"
                id="file"
                :ref="'excFile' + index"
                name="excFile"
              />
            </a>
            <p>
              (Excel文件，填写示例见模板内容)
              <a :href="`${downUrl}` + '/cjscweb/web/goldCJ/jzbs.xls'">
                <button class="down-load">模板下载</button>
              </a>
            </p>
          </div>
          <div v-show="item.showUploadExc" class="enclosure">
            <div class="list-label">附件：</div>
            <div class="file-name">
              <img src="../assets/link.png" alt="" />
              <div class="img-name">
                <span>
                  {{ item.excName }}
                </span>
              </div>
              <img class="right-img" src="../assets/riight.png" alt="" />
              <div class="delete-img" @click="deleteExc(index)">
                <img src="../assets/delect.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="upload upload-top">
          <div v-show="!item.showUploadImg">
            <a href="" class="upload-a"
              >*点击上传净值文件
              <input
                accept="application/pdf,image/png,image/jpg"
                @change="
                  uploadImg(
                    $event,
                    index,
                    item.uploadIndex,
                    item.prod_record_num
                  )
                "
                type="file"
                id="file"
                :ref="'file' + index"
                name="imgFile"
              />
            </a>
            <p>(盖章扫描件，格式为PDF或图片)</p>
          </div>
          <div v-show="item.showUploadImg" class="enclosure">
            <div class="list-label">附件：</div>
            <div class="file-name">
              <img src="../assets/link.png" alt="" />
              <div class="img-name">
                <span>
                  {{ item.imgName }}
                </span>
              </div>
              <img class="right-img" src="../assets/riight.png" alt="" />
              <div
                class="delete-img"
                @click="deleteImg(index, item.prod_record_num)"
              >
                <img src="../assets/delect.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="upload list">
          <div class="item">
            <div class="list-label">产品名称</div>
            <div class="right-input spec-name">
              <div class="cell">
                <p>
                  {{ item.prod_name }}
                </p>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">备案编码</div>
            <div class="right-input">
              <div class="cell">
                <input
                  type="text"
                  readonly
                  v-model="item.prod_record_num"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">产品策略</div>
            <div class="right-input">
              <div class="cell">
                <input
                  type="text"
                  readonly
                  v-model="item.prod_strategy"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">联系人</div>
            <div class="right-input">
              <div class="cell">
                <input
                  type="text"
                  readonly
                  v-model="item.prod_manager_name"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-time">
          <div class="time-top">
            <div
              class="time"
              v-for="(list, dateIndex) in item.preWeekDate"
              :key="dateIndex"
              :class="item.listIndex === dateIndex ? 'active' : ''"
              @click="changeTime(dateIndex, index)"
            >
              <p>{{ list.week | weekFilter }}</p>
              <p>{{ list.init_date | dateFilter }}</p>
            </div>
          </div>
          <div
            class="tab-content"
            v-for="(list, dateIndex) in item.preWeekDate"
            :key="dateIndex"
            v-show="item.listIndex === dateIndex ? true : false"
          >
            <div class="item">
              <div class="list-label">资产净值</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    v-model="list.asset_nav"
                    class="font-title-color right-span"
                    maxlength="100"
                    placeholder="请填写"
                    @input="
                      list.asset_nav = list.asset_nav.replace(/[^\d\.]/g, '')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="list-label">资产份额</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    v-model="list.asset_quota"
                    class="font-title-color right-span"
                    maxlength="100"
                    placeholder="请填写"
                    @input="
                      list.asset_quota = list.asset_quota.replace(
                        /[^\d\.]/g,
                        ''
                      )
                    "
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="list-label">单位净值</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    v-model="list.unit_nav"
                    class="font-title-color right-span"
                    maxlength="100"
                    placeholder="请填写"
                    @input="
                      list.unit_nav = list.unit_nav.replace(/[^\d\.]/g, '')
                    "
                  />
                </div>
              </div>
            </div>
            <div class="item">
              <div class="list-label">累计净值</div>
              <div class="right-input">
                <div class="cell">
                  <input
                    type="text"
                    v-model="list.accumulate_nav"
                    class="font-title-color right-span"
                    maxlength="100"
                    placeholder="请填写"
                    @input="
                      list.accumulate_nav = list.accumulate_nav.replace(
                        /[^\d\.]/g,
                        ''
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in monthList"
        :key="'m' + index"
        class="month-box"
        v-show="i_upload_type == '2' && proNameValue === item.prod_record_num"
      >
        <div class="upload list">
          <div class="item">
            <div class="list-label">备案编码</div>
            <div class="right-input">
              <div class="cell">
                <input
                  type="text"
                  readonly
                  v-model="item.prod_record_num"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">产品策略</div>
            <div class="right-input">
              <div class="cell">
                <input
                  v-model="item.prod_strategy"
                  readonly
                  type="text"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
          <div class="item">
            <div class="list-label">联系人</div>
            <div class="right-input">
              <div class="cell">
                <input
                  readonly
                  v-model="item.prod_manager_name"
                  type="text"
                  class="font-title-color right-span"
                  maxlength="100"
                  placeholder="请填写"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="upload upload-top">
          <div v-show="!item.showMonthExc">
            <a href="" class="upload-a"
              >*点击上传净值文件
              <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                @change="uploadFile($event, index, item)"
                type="file"
                id="file"
                name="monthExcFile"
              />
            </a>
            <p>
              (Excel文件，填写示例见模板内容)
              <a :href="`${downUrl}` + '/cjscweb/web/goldCJ/jzbs.xls'">
                <button class="down-load">模板下载</button>
              </a>
            </p>
          </div>
          <div v-show="item.showMonthExc" class="enclosure">
            <div class="list-label">附件：</div>
            <div class="file-name">
              <img src="../assets/link.png" alt="" />
              <div class="img-name">
                <span> {{ item.monthExcName }} </span>
              </div>
              <img class="right-img" src="../assets/riight.png" alt="" />
              <div class="delete-img" @click="deleteExc(index)">
                <img src="../assets/delect.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="upload upload-top">
          <div v-show="!item.showMonthImg">
            <a href="" class="upload-a"
              >*点击上传净值文件
              <input
                accept="application/pdf,image/png,image/jpg"
                type="file"
                id="file"
                name="monthPdfFile"
                @change="
                  uploadImg(
                    $event,
                    index,
                    item.uploadIndex,
                    item.prod_record_num
                  )
                "
              />
            </a>
            <p>(盖章扫描件，格式为PDF或图片)</p>
          </div>
          <div v-show="item.showMonthImg" class="enclosure">
            <div class="list-label">附件：</div>
            <div class="file-name">
              <img src="../assets/link.png" alt="" />
              <div class="img-name">
                <span>{{ item.monthPdfName }} </span>
              </div>
              <img class="right-img" src="../assets/riight.png" alt="" />
              <div
                class="delete-img"
                @click="deleteImg(index, item.prod_record_num)"
              >
                <img src="../assets/delect.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="month-list">
          <div class="search">
            <span class="span-title">产品名称</span>
            <div class="right-box">
              <div class="cell select-cell">
                <input
                  class="select-right-box"
                  readonly="readonly"
                  type="text"
                  @click="clickOrgSelect()"
                  v-model="proName"
                />
                <i class="ion-arrow"></i>
              </div>
              <!--下拉选择box-->
              <div class="select-box" v-show="showNameOptions" @click.stop>
                <cj-scroller direction="y" :noscrollbar="true">
                  <div class="scroller-box">
                    <p
                      class="font-normal-color over-long"
                      v-for="option in proNameOptions"
                      :key="option.value"
                      @click="selectNameOrgOptions(option.text, option.value)"
                    >
                      {{ option.text }}
                    </p>
                  </div>
                </cj-scroller>
              </div>
            </div>
          </div>
          <div class="content-list">
            <div class="month-tab">
              <div class="tab-son">净值日期</div>
              <div class="tab-son">资产净值</div>
              <div class="tab-son">资产份额</div>
              <div class="tab-son">单位净值</div>
              <div class="tab-son">累计净值</div>
            </div>
            <div class="month-content">
              <ul>
                <li v-for="(list, index1) in item.preMonthDate" :key="index1">
                  <div class="time">{{ list.init_date }}</div>
                  <div>{{ list.asset_nav }}</div>
                  <div>{{ list.asset_quota }}</div>
                  <div>{{ list.unit_nav }}</div>
                  <div>{{ list.accumulate_nav }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" @click="submitList()">提交</div>
    <mt-popup
      v-model="showPopup"
      class="sign-up-popup"
      popup-transition="popup-fade"
      :close-on-click-modal="false"
    >
      <div class="common-popup-box">
        <i class="close-popup-icon" @click="showPopup = false"></i>
        <h3 class="popup-title" v-show="isSuccess">提交成功</h3>
        <h3 class="popup-title" v-show="!isSuccess">提交失败</h3>
        <div class="popup-contend">
          <p v-show="!isSuccess">{{ errorMsg }}</p>
          <div class="img success-img" v-show="isSuccess">
            <img src="../assets/success-img.png" alt />
          </div>
          <div class="img failure-img" v-show="!isSuccess">
            <img src="../assets/failure-img.png" alt />
          </div>
          <div class="confirm-btn" @click="closeTips()">确认</div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import cache from '../proxy/cache.js'
import nativeService from '../services/common/nativeService.js'
import dateService from '../services/common/dateService.js'
import cjServices from '../services/cjServices.js'
import { Toast } from 'mint-ui'
import { cjScroller } from 'components'
export default {
  components: {
    cjScroller
  },
  filters: {
    weekFilter(value){
      switch (value) {
        case '1':
          return '周一';
        case '2':
          return '周二';
        case '3':
        return '周三';
        case '4':
        return '周四';
        case '5':
        return '周五';
      }
    },
    dateFilter(value) {
      value = dateService.format(new Date(value),'MM/DD')
      return value
    }
  },
  data() {
    return {
      // servers,
      timeObj: {
        asset_nav : '资产净值', 
        asset_quota : '资产份额', 
        unit_nav : '单位净值',
        accumulate_nav : '累计净值'
      },
      // 是否展示提交成功、失败提示弹窗
      showPopup: false,
      isSuccess: false,
      errorMsg: '',
      proList:[],
      // 下载地址
      downUrl:nativeService.isProduction() ? 'https://u.95579.com' : 'https://regard01.95579.com',
      tabTabArr: [
        {name: '周度报送',index: 0,type: '1'},
        {name: '月度报送',index: 1, type: '2'}
      ],
      selectTabIndex: 0,
      i_upload_type: '1',
      // 月度数据
      monthList: [],
      // 产品名称下拉
      proNameOptions: [],
      showNameOptions: false,
      proName: '',
      proNameValue: '',
      // 提醒是否显示
      tipShow: false,
      firstTip: '',
      secondTip: '',
      monthTipShow: false,
      monthFirstTip: '',
      monthSecondTip: '',
    }
  },
  methods:{
    tapClick(index,type) {
      if (this.selectTabIndex !== index) {
        this.selectTabIndex = index
        this.i_upload_type = type
      }
    },
    // 点击产品名称下拉
    clickOrgSelect() {
      this.showNameOptions = !this.showNameOptions
    },
    // 选择产品名称
    selectNameOrgOptions(text,value) {
      this.proName = text
      this.proNameValue = value
      this.showNameOptions = false
    },
    // 去空
    trimObj(arr) {
      for (var i in arr) {
        arr[i] = typeof arr[i] == 'string' ? arr[i].trim() : arr[i]
        if (i === 'preWeekDate'&& arr['preWeekDate']){
          for( let j = 0; j <= arr['preWeekDate'].length-1; j++){
          this.trimObj(arr['preWeekDate'][j])
          }
        }
      }
      return arr
    },
    // 检验周报
    vialist(arr) {
      // arr = this.trimObj(arr)
      // asset_nav asset_quota unit_nav accumulate_nav
      for(let i = 0; i < arr.length; i++) { 
        for(var j in arr[i]) {
          // delete arr[i].tip
          // delete arr[i].tip_mon
          // if(arr[i][j] === '') { 
          //   return i
          // } else 
          if (j ==='showUploadImg' && !arr[i]['showUploadImg']) {
            return 'pdf'
          } else if (j==='preWeekDate'&& arr[i]['preWeekDate'].length!==0) {
            for(let k = 0; k < arr[i]['preWeekDate'].length; k++){
              for(var h in arr[i]['preWeekDate'][k]){
                arr[i]['preWeekDate'][k][h] = typeof arr[i]['preWeekDate'][k][h] == 'string' ? arr[i]['preWeekDate'][k][h].trim() : arr[i]['preWeekDate'][k][h]
                if(Object.keys(this.timeObj).includes(h)) {
                  if(arr[i]['preWeekDate'][k][h] === ''){
                    return [i,k,h]
                  }
                }
              }
            }
          } 
        }
      }
    },
    // 检验月度
    viaMonthList(arr) {
      for(let i = 0; i < arr.length; i++) { 
        for(var j in arr[i]) {
          // delete arr[i].tip
          // delete arr[i].tip_mon
          // if(arr[i][j] === '') { 
          //   return i
          // } else 
          if (j ==='showMonthImg' && !arr[i]['showMonthImg']) {
            return 'pdf'
          } else if (j==='preMonthDate'&& arr[i]['preMonthDate'].length !== 0) {
            for(let k = 0; k < arr[i]['preMonthDate'].length; k++){
              for(var h in arr[i]['preMonthDate'][k]){
                arr[i]['preMonthDate'][k][h] = typeof arr[i]['preMonthDate'][k][h] == 'string' ? arr[i]['preMonthDate'][k][h].trim() : arr[i]['preMonthDate'][k][h]
                if(Object.keys(this.timeObj).includes(h)) {
                  if(arr[i]['preMonthDate'][k][h] === ''){
                    Toast({
                      message:'请确认每个产品的excel是否上传，并确认数据是否填写完整',
                      duration: 2000
                    })
                    return i
                  }
                }
              }
            }
          } 
        }
      }
    },
    // 提交
    submitList() {
      // 周度报送
      if(this.i_upload_type === '1') {
          // 避免数据为空 点击提交成功
        if (this.proList && this.proList.length === 0 ) {
        Toast({
              message: '暂无数据，无法提交',
              duration: 1000
          })
          return false
        }
        const i = this.vialist(this.proList)
        if(i instanceof Array){
          Toast({
              message: `请输入第${i[0]+1}条净值报送中的第${i[1]+1}个${this.timeObj[i[2]]}！`,
              duration: 3000
          })
          return 
        } else {
          if (i||i==0) {
            // pdf未上传
            if (i === 'pdf') {
              Toast({
                message: `请检查pdf是否全部上传`,
                duration: 3000
              })
              return false
            } else {
              Toast({
                message: `请填写完整第${i+1}个净值报送数据`,
                duration: 3000
              })
              return false

            }
          }
        }
        const obj = this.proList.map(l => {
          return {
            i_prod_record_num:l.prod_record_num,
            goldCJToken:cache.getLocalCache('goldCJToken'),
            i_nav_str: this.connectTimeData(l.preWeekDate)
          }
        })
        const arr1 = []
        for (let i = 0; i < obj.length; i++) {
          const a = this.handleSubmit(obj[i])
          arr1.push(a)
        } 
        Promise.all(arr1).then( res => {
          const data = res.filter((l) => {
            return l.error_code !== '0'
          })
          if (data.length > 0){
            this.showPopup = true
            this.isSuccess = false
            this.errorMsg = '提示:' + data[0].error_info
            }else {
              this.showPopup = true
              this.isSuccess = true

          }
        },(error) => {
          console.log(error,'error');
        }) 
      } else {
        if (this.monthList && this.monthList.length === 0 ) {
          Toast({
            message: '暂无数据，无法提交',
            duration: 1000
            })
          return false
        }
        const a = this.viaMonthList(this.monthList)
        if (!(a || a === 0)) {
          const obj = this.monthList.map(l =>{
            return {
              i_prod_record_num:l.prod_record_num,
              goldCJToken:cache.getLocalCache('goldCJToken'),
              i_nav_str: this.connectTimeData(l.preMonthDate)
            }
          })
          const arr2 = []
          for (let i =0; i < obj.length; i++) {
            const b = this.handleSubmit(obj[i])
            arr2.push(b)
          }
          Promise.all(arr2).then(res => {
            const data = res.filter((l) => {
              return l.error_code !== '0'
            })
            if (data.length > 0){
              this.showPopup = true
              this.isSuccess = false
              this.errorMsg = '提示:' + data[0].error_info
              }else {
                this.showPopup = true
                this.isSuccess = true
  
            }
          },(error) => {
            console.log(error,'error');
          }) 
        } else if (a === 'pdf') {
          // pdf不存在
          Toast({
            message:'请检查pdf是否全部上传',
            duration: 2000
          })
          return false
        }
      }
    }, 
    // 拼接数据
    connectTimeData(timeArr) {
      let str = ''
      for (let i = 0; i < timeArr.length; i++) {
        let item = timeArr[i]
        if (timeArr.length >= 2 && i < timeArr.length - 1){
          str += item.asset_nav + ';' + item.asset_quota + ';' + item.unit_nav + ';' + item.accumulate_nav + ';' + item.init_date +'@@'

        } else {
          str += item.asset_nav + ';' + item.asset_quota + ';' + item.unit_nav + ';' + item.accumulate_nav + ';' + item.init_date
        }
      }
      return str
    },
     //点击时间切换
    changeTime(sonIndex,index) {
      this.proList[index].listIndex = sonIndex
    }, 
    // 上传exc文件
    uploadFile(e,index,item) {
      const arr = []
      if (this.i_upload_type === '1') {
        for( let i =0; i< item.preWeekDate.length; i++){
          arr.push(item.preWeekDate[i].init_date + '_' + item.preWeekDate[i].week)
        }
      } else {
        for( let i =0; i< item.preMonthDate.length; i++){
          arr.push(item.preMonthDate[i].init_date + '_' + item.preMonthDate[i].week)
        }
      }
      console.log(arr.join(','));
      const fileName = e.target.files[0]
       let form = new FormData(); // FormData 对象
      form.append("excelFile", fileName)
      form.append("goldCJToken", cache.getLocalCache('goldCJToken'))
      form.append("prod_record_num", item.prod_record_num)
      form.append("init_dates", arr.join(','))
      cjServices.uploadExc(this,form).then(res => {
        if (res.body && res.body.error_code == '0') {
          if (res.body.results && res.body.results.length !== 0) {
            if (this.i_upload_type === '1') {
              this.proList[index].excName =  e.target.files[0].name
              e.target.value = ''
              this.proList[index].showUploadExc = true
              const arr1 = JSON.parse(JSON.stringify(res.body.results))
              let arr2 =JSON.parse(JSON.stringify(this.proList[index].preWeekDate)) 
              for(let i =0; i< arr1.length; i++){
                for(let j =0; j< arr2.length; j++) {
                  if (arr1[i].init_date === arr2[j].init_date){
                    arr2[j] = arr1[i]
                  } 
              }
              }
              this.proList[index].preWeekDate = arr2

            } else {
               this.monthList[index].monthExcName =  e.target.files[0].name
              e.target.value = ''
              this.monthList[index].showMonthExc = true
              const arr1 = JSON.parse(JSON.stringify(res.body.results))
              let arr2 =JSON.parse(JSON.stringify(this.monthList[index].preMonthDate)) 
              for(let i =0; i< arr1.length; i++){
                for(let j =0; j< arr2.length; j++) {
                  if (arr1[i].init_date === arr2[j].init_date){
                    arr2[j] = arr1[i]
                  } 
              }
              }
              this.monthList[index].preMonthDate = arr2
            }
          } else {
            if (this.i_upload_type === '1') {
              Toast({
                message: '请在excel中包括上周您所选产品对应的净值信息',
                duration: 3000
              })
            } else {
              Toast({
                message: '请在excel中包括上月您所选产对应的净值信息并填写完整',
                duration: 3000
              })
            }
          }
        } else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            });
          cache.clearLocalCache('goldCJToken')
          this.$router.push('/index')
         } else {
            e.target.value = ''
            Toast({
              message: res.body.error_info,
              duration: 2000
            })
        }
      })
    },  
    // 上传pdf
    uploadImg(e,index,uploadIndex,prod_record_num) {
      if(index === uploadIndex){
          const fileName = e.target.files[0]
           let form = new FormData(); // FormData 对象
          form.append("pdfFile", fileName)
          form.append("goldCJToken", cache.getLocalCache('goldCJToken'))
          form.append("i_upload_type", this.i_upload_type)
          form.append("i_prod_record_num", prod_record_num)
           cjServices.uploadPdf(this,form).then(res => {
            if (res.body && res.body.error_code == '0') {
              if (this.i_upload_type === '1') {
                this.proList[index].imgName =  e.target.files[0].name
                // 解决不同input上传一样的文件上传不了的问题
                e.target.value = ''
                // this.$refs.file+index.value === null
                this.proList[index].showUploadImg = true
              } else {
                this.monthList[index].monthPdfName = e.target.files[0].name
                e.target.value = ''
                this.monthList[index].showMonthImg = true
              }
            }else if (res.body.error_code == '-9999') {
            //  token失效
              Toast({
                message: res.body.error_info,
                duration: 2000
              });
            cache.clearLocalCache('goldCJToken')
            this.$router.push('/index')
           } else {
              Toast({
                message: res.body.error_info,
                duration: 2000
              })
              e.target.value = ''
           }
          })
      }
    },
    // 删除exc 
    deleteExc(index) {
      if (this.i_upload_type === '1') {
        this.proList[index].showUploadExc = false
        const arr = JSON.parse(JSON.stringify(this.proList[index].preWeekDate))
        this.proList[index].preWeekDate = arr.map(l=>{
          return {
            ...l,
            asset_nav: '',
            asset_quota: '',
            unit_nav: '',
            accumulate_nav: '',
          }
        })
      } else {
          this.monthList[index].showMonthExc = false
          const arr = JSON.parse(JSON.stringify(this.monthList[index].preMonthDate))
        this.monthList[index].preMonthDate = arr.map(l=>{
          return {
            ...l,
            asset_nav: '',
            asset_quota: '',
            unit_nav: '',
            accumulate_nav: '',
          }
        })
      }
    },
    // 删除pdf
    deleteImg(index,prod_record_num) {
      if (this.i_upload_type === '1') {
        this.proList[index].showUploadImg = false
      } else {
        this.monthList[index].showMonthImg = false
      }
      const data = {
        goldCJToken: cache.getLocalCache('goldCJToken'),
        i_prod_record_num: prod_record_num,
        i_upload_type:this.i_upload_type
      }
      cjServices.deletePdf(this,data).then(res => {
        if (res.body && res.body.error_code == '0') {
          Toast({
              message: res.body.error_info,
              duration: 2000
          });
        } else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            });
          cache.clearLocalCache('goldCJToken')
          this.$router.push('/index')
         }  else {
           Toast({
              message: res.body.error_info,
              duration: 2000
            })
        }
      })
    },
    // 获取整个列表数据
    getProList() {
      cjServices.getDataList(this,{goldCJToken:cache.getLocalCache('goldCJToken') }).then(res => {
         if (res.body && res.body.error_code == '0') {
           this.proList = res.body.results.map((l,index) => {
             return {
               ...l,
              listIndex:0,
              uploadIndex:index,
              //图片是否上传
              showUploadImg:false,
              showUploadExc:false,

            }
          })
          if (res.body.results && res.body.results[0] && res.body.results[0].tip) {
            this.firstTip = res.body.results[0].tip

          }
          if (res.body.results && res.body.results[0] && res.body.results[0].preWeekDate && res.body.results[0].preWeekDate[0].tip !== '') {
            this.secondTip = res.body.results[0].preWeekDate[0].tip
          }
          if (this.firstTip !== '' || this.secondTip != '') {
            this.tipShow = true
          }
          console.log(this.proList,'列表数据')
         } else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            })
          cache.clearLocalCache('goldCJToken')
           nativeService.routerRedirect('/index', this)

         } else {
            Toast({
                message: res.body.error_info,
                duration: 2000
            })
        }
      })
    }, 
    // 获取月度数据
    getMonthList() {
      cjServices.getMonthDataList(this,{goldCJToken:cache.getLocalCache('goldCJToken') }).then(res => {
        if (res.body && res.body.error_code == '0') {
          if (res.body.results && res.body.results.length !== 0) {
            this.proNameOptions = res.body.results.map(l=>{
              return {
                text: l.prod_name,
                value: l.prod_record_num
              }
            })
            this.proNameValue = this.proNameOptions[0].value
            this.proName = this.proNameOptions[0].text
          }
          this.monthList = res.body.results.map((l,index) => {
             return {
               ...l,
              uploadIndex:index,
              //图片是否上传
              showMonthImg:false,
              showMonthExc:false,
            }
          })
          if (res.body.results && res.body.results[0] && res.body.results[0].tip_mon) {
            this.monthFirstTip = res.body.results[0].tip_mon
          }
          if (res.body.results && res.body.results[0] && res.body.results[0].preMonthDate && res.body.results[0].preMonthDate[0].tip !== '') {
            this.monthSecondTip = res.body.results[0].preMonthDate[0].tip
          }
          if (this.monthFirstTip !== '' || this.monthSecondTip != '') {
            this.monthTipShow = true
          }
          console.log(this.monthList,'月度数据')
        } else if (res.body.error_code == '-9999') {
          //  token失效
            Toast({
              message: res.body.error_info,
              duration: 2000
            })
            cache.clearLocalCache('goldCJToken')
            nativeService.routerRedirect('/index', this)
        } else {
            Toast({
                message: res.body.error_info,
                duration: 2000
            })
        }
      })
    },
    // 提交接口封装
    handleSubmit(obj) {
      if (this.i_upload_type === '1') {
        return new Promise((resolve) => {
          cjServices.netValueSubmit(this,obj).then(res => {
            if (res.body.error_code === '-9999'){
              Toast({
                message: res.body.error_info,
                duration: 2000
              });
              cache.clearLocalCache('goldCJToken')
              nativeService.routerRedirect('/login', this)
            } else if (res.body && res.body.error_code !== '-9999') {
              resolve({'error_code':res.body.error_code,'error_info':res.body.error_info})
            }
          })
        })
      } else {
        return new Promise((resolve) => {
          cjServices.monthValueSubmit(this,obj).then(res => {
            if (res.body.error_code === '-9999'){
              Toast({
                message: res.body.error_info,
                duration: 2000
              });
              cache.clearLocalCache('goldCJToken')
              nativeService.routerRedirect('/login', this)
            } else if (res.body && res.body.error_code !== '-9999') {
              resolve({'error_code':res.body.error_code,'error_info':res.body.error_info})
            }
          })
        })
      }
    },
    // 关闭提示
    closeTips() {
      this.showPopup = false
    },
    goBack() {
      nativeService.routerRedirect(-1, this)
    },
    isCjehApp() {
      if (navigator.userAgent.indexOf('cjsccjeh') > -1) {
        return true
      } else {
        return false
      }

    }
  },
  created () {
    this.getProList()
    this.getMonthList()
  }
}
</script>


<style lang="scss" scoped>
@import "sass/gold/common.scss";
@import "sass/gold/weekList.scss";
</style>